import makeTypeCreator from '@/models/makeTypeCreator'

const namespace = 'socket'
const createType = makeTypeCreator(namespace)

export const RTM_CONV_CREADTED = createType('RTM_CONV_CREADTED')
export const RTM_ORDER_UPDATED = createType('RTM_ORDER_UPDATED')
export const RTM_ORDER_MESSAGE = createType('RTM_ORDER_MESSAGE')
export const RTM_MANAGER_WORKING_STATE_CHANGED = createType('RTM_MANAGER_WORKING_STATE_CHANGED')
export const RECEIVER_OFFLINE = createType('RECEIVER_OFFLINE')
export const RTM_NOTIFY_CENTER_MESSAGE = createType('RTM_NOTIFY_CENTER_MESSAGE')
export const RTM_NOTIFY_USER_SUBSCRIBE = createType('RTM_NOTIFY_USER_SUBSCRIBE')
export const TASK_REFRESH = createType('TASK_REFRESH')
export const CONV_REFRESH = createType('CONV_REFRESH')
export const TODO_REFRESH = createType('TODO_REFRESH')
export const CHAOSHI_REFRESH = createType('CHAOSHI_REFRESH')
export const REPLY_REFRESH = createType('REPLY_REFRESH')
export const ORDER_UPDATED_REFRESH = createType('ORDER_UPDATED_REFRESH')



